import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=040b78b0&scoped=true&"
var script = {}
import style0 from "./Location.vue?vue&type=style&index=0&id=040b78b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b78b0",
  null
  
)

export default component.exports